import { render, staticRenderFns } from "./UserFamilyParents.vue?vue&type=template&id=072899a0&"
import script from "./UserFamilyParents.vue?vue&type=script&lang=js&"
export * from "./UserFamilyParents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072899a0')) {
      api.createRecord('072899a0', component.options)
    } else {
      api.reload('072899a0', component.options)
    }
    module.hot.accept("./UserFamilyParents.vue?vue&type=template&id=072899a0&", function () {
      api.rerender('072899a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserFamilyParents.vue"
export default component.exports